import { useContext } from 'react';

import { TakeTourContext } from './TakeTourContext';

export const useTakeTourContext = () => {
  const context = useContext(TakeTourContext);
  if (!context) {
    throw new Error('useTakeTourContext must be used within a TakeTourProvider');
  }
  return context;
};
